import React from 'react'
import { Divider } from 'src/component/divider/divider'
import { PersonalDetails } from 'src/component/profile/personal-info/personal-details/personal-details'
import { Profile } from 'src/component/profile/personal-info/profile/profile'
import { ProfilePhoto } from 'src/component/profile/personal-info/profile-photo'

export const PersonalInfo = (): React.ReactElement => {
  return (
    <div className="p-6 md:p-10 bg-primary-gray rounded-md">
      <h3 className="font-evogria text-2xl md:text-4xl text-primary uppercase mb-10">Personal info</h3>
      <ProfilePhoto />
      <Divider className="my-6" />
      <PersonalDetails />
      <Divider className="my-6" />
      <Profile />
    </div>
  )
}
